module.exports = __webpack_public_path__ + "static/media/web_dev.efa0ae8d.png";